//import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {MessageService} from './../base/message.service';

import {Service} from './../base/service';
import {Loggers} from '../../../util/app-util';
import { cosechaEntity } from '../../../elements/riesgo-credito/entities_riesgos/entities_riesgos';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CosechasService extends Service<cosechaEntity>{

  httpClient: HttpClient;
  constructor(
    http: HttpClient,
    messageService: MessageService,
    protected override logger: Loggers,
    cookiesService: CookieService
  ) { 
    super('concentracion','',http, messageService, logger, cookiesService);
    this.httpClient = http;
  }

  protected getParams(entity: cosechaEntity):HttpParams{
    let params: HttpParams = new HttpParams();
    if (null == entity){return params;}
    if (null != entity.InstitucionId){params = params.set('InstitucionId', entity.InstitucionId)}
    if (null != entity.Periodo){params = params.set('Periodo', entity.Periodo)}
    if (null != entity.PAR){params = params.set('PAR', entity.PAR)}
    if (null != entity.BnPAR_Inclusive){params = params.set('BnPAR_Inclusive', entity.BnPAR_Inclusive)}
    if (null != entity.NPeriodosHst){params = params.set('NPeriodosHst', entity.NPeriodosHst)}
    if (null != entity.ZonaId){params = params.set('ZonaId', entity.ZonaId)}
    if (null != entity.ProductoId){params = params.set('ProductoId', entity.ProductoId)}
    if (null != entity.SectorId){params = params.set('SectorId', entity.SectorId)}
    if (null != entity.SucursalId){params = params.set('SucursalId', entity.SucursalId)}
    if (null != entity.AsesorId){params = params.set('AsesorId', entity.AsesorId)}
    // if (null != entity.BnConIntereses){params = params.set('BnConIntereses', entity.BnConIntereses.toString())}
    return params;
  }

}
